const lineHeights = ["1.0", "1.15", "1.5", "2.0", "2.5", "3.0"];

export default lineHeights;
